































































import { Action, Getter } from "vuex-class";
import { Component, Mixins, Vue } from "vue-property-decorator";
import Configuration from "front-component/Configuration";
import CentralInsert from "@/components/miscellaneous/CentralInsert.vue";
import router from "@/router";
import _ from "lodash";
import Auth from "front-component/Auth";
import CommonAuthMixin from "@/mixins/auth/CommonAuthMixin";

const components = {
    CentralInsert,
};
@Component({ components })
export default class Login extends Mixins(CommonAuthMixin) {

    private login: string = "";
    private password: string = "";

    @Getter("isLoading") public isLoading!: boolean;
    @Action("fetchCurrentUserData") public fetchCurrentUserData!: any;

    public get disableSubmit(): boolean {
        return this.isLoading || !this.login || !this.password;
    }

    public toLogIn(): void {
        if (!this.disableSubmit) {
            Auth.basicAuthenticate(
                Configuration.get("authUri"),
                Configuration.get("applicationId"),
                this.login,
                this.password
            ).then(() => {
                this.fetchCurrentUserData().then(() => {
                    this.$router.push({ name: "redirect" });
                });
            }).catch(() => {
                this.handleMessage("error", "failedAuthentication");
            });
        }
    }

    public toLogInBySso(): void {
        const subDomain = this.getSubDomain();
        if (subDomain) {
            window.open(`${Configuration.get("authUri")}/ssos/${subDomain}/application/cockpit-id/login`, "_self");
        } else {
            Auth.goToSsoAuthentication(
                Configuration.get("ssoUri"),
                location.origin + router.resolve({ name: "token" }).href,
                _.get(this.$router, "currentRoute.fullPath", "")
            );
        }
    }
}
